var _templateObject = _taggedTemplateLiteralLoose(['\n  color: ', ';\n'], ['\n  color: ', ';\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Theme from '../../Theme';

var Message = styled.div(_templateObject, Theme.colors.danger);

var ErrorText = function ErrorText(_ref) {
  var errors = _ref.errors,
      touched = _ref.touched,
      field = _ref.field;
  return touched[field] && errors[field] ? React.createElement(
    Message,
    null,
    errors[field]
  ) : null;
};

ErrorText.propTypes = process.env.NODE_ENV !== "production" ? {
  errors: PropTypes.object,
  touched: PropTypes.object,
  field: PropTypes.string
} : {};

export default ErrorText;